export default "https://storage.googleapis.com/prepweb-prod/dist/b11df04c7b41c55c0af2c6232dc4a9f7.svg";